import { render } from "./DefinitionOfEffectById.vue?vue&type=template&id=75a00546&scoped=true"
import script from "./DefinitionOfEffectById.vue?vue&type=script&lang=js"
export * from "./DefinitionOfEffectById.vue?vue&type=script&lang=js"

import "./DefinitionOfEffectById.vue?vue&type=style&index=0&id=75a00546&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a00546"]])

export default __exports__